// extracted by mini-css-extract-plugin
export default {"cartContainer":"BN","summarycontent":"CN","offset":"EN","leaf":"FN","summaryclosed":"GN","summaryheader":"HN","summaryitems":"IN","summaryprice":"JN","buttonopen":"KN","buttondown":"LN","summaryfixed":"MN","usdnotification":"NN","renew":"ON","promowrapper":"PN","ordersummarywrap":"QN","simplewrap":"RN"};
    if(module.hot) {
      // 1713996748668
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  